<template>


    <div>
        

        <b-card :style="{'max-width': '2000px', 'width': '1500px', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
            <b-card-text>
                <h4>Vendor Orders</h4>
                <b-alert variant="secondary" show><sub>All vendor orders are shown here. Anything that has been made in-stock is not shown. This way we keep the list in control. We can always pull all the archived vendor orders on demand, and modify them. If an order that is already been placed in stock is reverted and put again in some other state, it gets deducted from the inventory of the losub of which it was made part of. Once item is put in-stock, its location cannot be changed.</sub></b-alert>
            </b-card-text>
            <b-card-text>
                <b-alert variant="secondary" show style="display: inline-block;">
                    <div style="display: inline-block;">
                        <b-form-select v-model="vendor_order_type" :options="vendor_order_types" v-on:change="get_vendor_orders">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- SELECT VENDOR ORDER TYPE --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div style="display: inline-block;">
                        <b-button @click="get_vendor_orders">REFRESH</b-button>
                    </div>
                </b-alert>

                <b-alert variant="secondary" show style="display: inline-block;  width: auto;">
                    <div style="display: inline-block;">
                        <b-input style="width: 300px;" v-model="search_query" @change="filter_list" placeholder="ENTER PO# OR INVOICE # TO FILTER">
                        </b-input>
                    </div>

                    <div style="display: inline-block;">
                        <b-button @click="filter_list">FILTER</b-button>
                    </div>
                </b-alert>
            </b-card-text>

            <div>
                
                <loading :active="items_being_loaded" 
                    :can-cancel="false" 
                    :is-full-page="true">
                </loading>

                <div v-if="items.length > 0" style="margin-top: 10px;">
                    
                    <table class="text-monospace" style="width: 100%; margin-top: 10px;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <td class="ipt_tdhr" v-on:click="sortby('sale_invoice_id')">
                                    CUSTOMER INV ID
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('customer_fullname')">
                                    CUSTOMER NAME
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('customer_phone')">
                                    CUSTOMER PHONE
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('vendor_invoice_id')">
                                    PO #
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('product_sku')">
                                    PRODUCT  SKU
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('vendor')">
                                    VENDOR
                                </td>
                                <td class="ipt_tdhr">
                                    QTY
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('vendor_order_status')">
                                    STATUS
                                </td>
                                <td class="ipt_tdhr" v-on:click="sortby('eta')">
                                    ETA
                                </td>
                                <td class="ipt_tdhr">
                                    ADDED TO
                                </td>
                                <td class="ipt_tdhr">
                                    ORDERED ON
                                </td>
                                <td class="ipt_tdhr">
                                    USER
                                </td>
                                <td class="ipt_tdhr">
                                    LAST UPDATE
                                </td>
                                <td class="ipt_tdhr">
                                    ARCHIVED
                                </td>
                                <td class="ipt_tdhr">
                                    ACTION
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="item, idx in items" v-bind:key="idx" v-if="belongs_to_filter_value(item) == true">
                                <td class="ipt_tdr" style="">
                                    {{ item.sale_invoice_id }}
                                </td>
                                <td class="ipt_tdr" style="">
                                    {{ item.customer_fullname }}
                                </td>
                                <td class="ipt_tdr" style="">
                                    {{ item.customer_phone }}
                                </td>
                                <td class="ipt_tdr" style="width: 150px;">
                                    <b-input size="sm" style="font-size: 11px;" v-model="item.vendor_invoice_id"></b-input>
                                </td>
                                <td class="ipt_tdr">
                                    <span v-if="item.vendor_order_type == 2">
                                        <b-input size="sm" v-model="item.product_sku"></b-input>
                                    </span>
                                    <span v-else>
                                        {{ item.product_sku }}
                                    </span>
                                </td>
                                <td class="ipt_tdr" style="width: 100px;">
                                    {{ item.vendor }}
                                </td>
                                <td class="ipt_tdr" style="width: 50px; text-align: center;">
                                    <b-input size="sm" style="width: 50px; font-size: 11px; text-align: center;" v-model="item.quantity"></b-input>
                                </td>
                                <td class="ipt_tdr">
                                    <b-form-select style="width: 100px; font-size: 11px;" v-model="item.vendor_order_status" :options="vendor_order_statuses"></b-form-select>
                                </td>

                                <td class="ipt_tdr" style="width: 100px;">
                                    <!-- <flat-pickr  :config="{ dateFormat: 'm-d-Y', mode: 'single' }" style="" v-model="item.eta"></flat-pickr> -->

          


                                     <date-picker v-model="item.eta" format="MM-DD-YYYY" valueType="format"
                                     style="width: 130px; font-size: 9px;" 
                                    
                                    ></date-picker>
                                </td>

                                <td class="ipt_tdr">
                                    <span v-if="item.vendor_order_status == 3 && !item.location_id ">
                                        <b-form-select style="width: 250px; font-size: 10px;" v-model="item.locsub" :options="packet.locsubs"></b-form-select>
                                    </span>
                                    <span v-else>
                                        {{ packet.locsubsdict[item.location_id + '|' + item.sublocation_id] }}
                                    </span>
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.vendor_order_date }}
                                </td>

                                <td class="ipt_tdr">
                                    {{ item.last_action_user }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.ts_last_action }}
                                </td>
                                <td class="ipt_tdr">
                                    <b-form-select style="width: 100px; font-size: 11px;" v-model="item.archived" :options="vendor_order_archived_statuses"></b-form-select>
                                </td>
                                <td class="ipt_tdr">
                                    <button @click="update_vendor_order_wrapper(item)" :disabled="is_action_disabled()">SAVE</button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <b-alert show variant="warning">No records</b-alert>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"

    export default {
        name: "AdminToolsVendorOrders",
        components: {Backer, Loading, DatePicker},
        data: function() {
            return {
                packet: {},
                sort_asc: true,
                items: [],
                items_being_loaded: false,
                vendor_order_types: [
                    {value: 1, text: "BACKORDERS", selected: true},
                    {value: 2, text: "SPECIAL ORDERS"},
                    {value: -1, text: "BACKORDERS (ARCHIVED)" },
                    {value: -2, text: "SPECIAL ORDERS (ARCHIVED)" },
                ],
                vendor_order_statuses: [
                    {value: 0, text: "OPEN"},
                    {value: 1, text: "ORDERED"},
                    {value: 2, text: "IN-TRANSIT"},
                    {value: 3, text: "RECEIVED"},
                    {value: 4, text: "DISCONTINUED"},
                ],
                vendor_order_archived_statuses: [
                    {value: true, text: "TRUE"},
                    {value: false, text: "FALSE"}
                ],
                vendor_order_type: null,
                show_archived: false, 
                sort_asc: true,
                search_query: null,
                filter_value: null
            }
        },
        methods: {
            is_action_disabled: function(e){
                let status = false;
                if (e){
                    e.preventDefault();
                }
                let userrole= this.packet.userDetails.userrole;
                if (['locationadmin', 'salesperson', 'warehouseuser', 'warehousemanager'].includes(userrole)){
                    status = true
                }
                return status
            },
            belongs_to_filter_value: function(item){
                if (!this.search_query || this.search_query.length == 0){
                    return true
                }
                else {
                    return ( 
                        (item.vendor_invoice_id || '').toLowerCase().indexOf(this.search_query.toLowerCase()) > -1
                        ||
                        (item.sale_invoice_id || '').toLowerCase().indexOf(this.search_query.toLowerCase()) > -1

                        ||

                        (item.customer_fullname || '').toLowerCase().indexOf(this.search_query.toLowerCase()) > -1

                        ||

                        (item.customer_phone || '').toLowerCase().indexOf(this.search_query.toLowerCase()) > -1
                    )
                }
            },
            filter_list: function(){
                //console.log(this.search_query);

                this.filter_value = this.search_query;
            },
            update_vendor_order_wrapper: function(item){
                let that = this;
                let quantity = parseInt(item.quantity);
                if (isNaN(quantity) || quantity <= 0){
                    this.$vex.dialog.alert({
                        message: "Please provide a valid non-zero quantity for the order."
                    });
                    return
                }
                item.quantity = quantity;

                if (item.vendor_order_status != 3){
                    this.update_vendor_order(item);
                }
                else {
                    if (item.location_id){
                        this.update_vendor_order(item);
                    }
                    else {
                        if (!item.locsub){
                            this.$vex.dialog.alert({
                                message: "Please select a location where the item has to be added."
                            });
                            return
                        }
                        else {
                            let splitted = item.locsub.split("|");
                            item.location_id = parseInt(splitted[0]);
                            item.sublocation_id = parseInt(splitted[1]);

                            this.$vex.dialog.confirm({
                                message: "Setting a DELIVERED status with a location will add the given quantity of products to the inventory.  Are you sure?",
                                callback: function (value) {
                                    if (value) {
                                        that.update_vendor_order(item)
                                    } else {
                                        return
                                    }
                                }
                            });
                        }
                    }
                }

            },

            update_vendor_order: function(item){
                let that = this;
                let path = "/api/sales/update_vendor_order/"
                let data = item;
                let quantity = parseInt(data.quantity);
                if (isNaN(quantity) || quantity <= 0){
                    this.$vex.dialog.alert({
                        message: "Please provide a valid non-zero quantity for the order."
                    });
                    return
                }
                data.quantity = quantity;
                
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully updated vendor order.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f =  function(error){
                    that.$bvToast.toast(
                        "Error updaing vendor order.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postAsync(path, data, s, f);
            },
            get_vendor_orders: function(){
                let data = {vendor_order_type: this.vendor_order_type, archived: this.show_archived};

                if (!this.vendor_order_type){
                    this.$vex.dialog.alert({
                        message: "Please select a type of vendor order to show orders."
                    });
                    return
                }

                if (data.vendor_order_type < 0){
                    data.archived = true;
                    data.vendor_order_type *= -1;
                }

                if (this.packet.userDetails.properties.location_id){
                    data.location_id = data.location_id;
                }

                let that = this;
                let path ="/api/sales/get_vendor_orders/"
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.items = response.data.result;
                    }
                    
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "Error loading vendor orders. Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                that.items = []
                Requestor.getSync(path, data, s, f);

            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
        }
    }
</script>

<style scoped>
    .non-header {
        font-weight: normal;
        font-size: 12px;
    }

    .ipt_tdhr {
        font-weight: normal;
        font-size: 11px;
        background: silver;
    }
    .ipt_tdr {
        font-weight: normal;
        font-size: 11px;
        background: aliceblue;

    }

    .input-eta {
       font-size: 11px; text-align: center; border: 0px solid gray;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsVendorOrders.vue